module.exports = __webpack_public_path__ + "caaad00bd89e5ecf7349846965542994.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-purple.png
// module id = 2201
// module chunks = 0